/** 
	Cette fonction prend un tableau en premier argument et permets de faire un chunk (partitionner un tableau en sous-tableaux de taille fixe).
*/
export function chunkArray<T>(array: T[], size: number): T[][] {
	if (!Array.isArray(array)) {
		throw new TypeError('Le premier argument doit être un tableau');
	}
	if (typeof size !== 'number' || size <= 0) {
		throw new TypeError('La taille du chunk doit être un entier positif');
	}

	const result: T[][] = [];

	for (let i = 0; i < array.length; i += size) {
		result.push(array.slice(i, i + size));
	}

	return result;
}

/** 
	Cette fonction prend un tableau en premier argument et retourne une copie de ce tableau 
	en plaçant en première position l'item qui match la condition de la callback predicate.
*/
export function moveItemToFront <T>(array: T[], predicate: (item: T) => boolean): T[] {
	const index = array.findIndex(predicate);

	if (index === -1) {
		return [...array];
	}

	const [item] = array.slice(index, index + 1);
	const rest = array.filter((_, i) => i !== index);
	return [item, ...rest];
}